/** UI status keys for step rows */
export const STEP_STATUS = {
  PENDING: "pending",
  IN_PROGRESS: "inProgress",
  WAITING: "waiting",
  NEEDS_ACTION: "needsAction",
  REVIEWING: "reviewing",
  COMPLETED: "completed",
  REJECTED: "rejected",
  NOT_REQUIRED: "notRequired",
};

export const STEP_STATUS_LABELS = {
  [STEP_STATUS.PENDING]: "در انتظار",
  [STEP_STATUS.IN_PROGRESS]: "در حال انجام",
  [STEP_STATUS.WAITING]: "در انتظار",
  [STEP_STATUS.NEEDS_ACTION]: "نیاز به اقدام متقاضی",
  [STEP_STATUS.REVIEWING]: "در بررسی",
  [STEP_STATUS.COMPLETED]: "تکمیل‌شده",
  [STEP_STATUS.REJECTED]: "رد شده",
  [STEP_STATUS.NOT_REQUIRED]: "عدم نیاز",
};

export const STEP_STATUS_CHIP_COLOR = {
  [STEP_STATUS.PENDING]: "info",
  [STEP_STATUS.IN_PROGRESS]: "info",
  [STEP_STATUS.WAITING]: "default",
  [STEP_STATUS.NEEDS_ACTION]: "info",
  [STEP_STATUS.REVIEWING]: "warning",
  [STEP_STATUS.COMPLETED]: "success",
  [STEP_STATUS.REJECTED]: "error",
  [STEP_STATUS.NOT_REQUIRED]: "default",
};

export const MEHRSAN_STAGE_STEPS = [
  {
    id: 1,
    title: "ثبت‌نام اولیه / انتقال پلتفرم",
    responsibleLabel: "",
  },
  {
    id: 2,
    title: "تحویل مدارک به شرکت توزیع",
    responsibleLabel: "",
  },
  {
    id: 3,
    title: "عقد قرارداد مهرسان",
    responsibleLabel: "کارشناس مهرسان",
  },
  {
    id: 4,
    title: "بارگذاری و تأیید قرارداد مهرسان",
    responsibleLabel: "",
  },
];

export const LOAN_STAGE_STEPS = [
  { id: 1, title: "ارسال متقاضی به لندتک", actorLabel: "" },
  { id: 2, title: "استعلام‌های متقاضی", actorLabel: "لندتک" },
  { id: 3, title: "تکمیل پروفایل در لندتک", actorLabel: "لندتک" },
  { id: 4, title: "آپلود چک", actorLabel: "متقاضی" },
  { id: 5, title: "تأیید اولیه چک", actorLabel: "لندتک" },
  { id: 6, title: "ارسال فیزیکی چک", actorLabel: "لندتک" },
  { id: 7, title: "تأیید نهایی چک", actorLabel: "لندتک" },
  { id: 8, title: "عقد قرارداد بانک با متقاضی", actorLabel: "بانک" },
  { id: 9, title: "واریز وام به حساب سولارنت", actorLabel: "بانک" },
];

/** Known dynamic workflow stage codes (non-legacy Barq LoanStep*). */
export const WORKFLOW_STAGE_TITLES = {
  IriaSubmitApplicant: { title: "ثبت درخواست", actorLabel: "اپراتور" },
  IriaSubmitRequest: { title: "ثبت درخواست", actorLabel: "اپراتور" },
  IriaInquiryPending: { title: "در انتظار احراز هویت", actorLabel: "ایریاپی" },
  IriaInquiryDone: { title: "احراز هویت انجام شد", actorLabel: "ایریاپی" },
  IriaContractRequested: { title: "درخواست فایل قرارداد", actorLabel: "ایریاپی" },
  IriaContractDownloaded: { title: "دریافت فایل قرارداد", actorLabel: "ایریاپی" },
  IriaSignedUploaded: { title: "آپلود فایل امضا شده", actorLabel: "متقاضی" },
  IriaBankPending: { title: "در انتظار تأیید بانک", actorLabel: "بانک" },
  IriaCreditCheck: { title: "در انتظار احراز هویت", actorLabel: "ایریاپی" },
  IriaDocumentCollect: { title: "احراز هویت انجام شد", actorLabel: "ایریاپی" },
  IriaContractSign: { title: "درخواست فایل قرارداد", actorLabel: "ایریاپی" },
  IriaDisburse: { title: "اعطای تسهیلات", actorLabel: "ایریاپی" },
  IriaCompleted: { title: "تکمیل شده", actorLabel: "ایریاپی" },
  YeksaSubmitApplicant: { title: "ارسال متقاضی به یکساپی", actorLabel: "اپراتور" },
  YeksaCreditCheck: { title: "اعتبارسنجی", actorLabel: "یکساپی" },
  YeksaApproval: { title: "تأیید نهایی", actorLabel: "یکساپی" },
  YeksaDisburse: { title: "واریز تسهیلات", actorLabel: "یکساپی" },
};

/** Iria admin portal timeline (9 steps). */
export const IRIA_PORTAL_STAGE_STEPS = [
  { id: 1, stageCode: "IriaSubmitRequest", title: "ثبت درخواست", actorLabel: "اپراتور" },
  { id: 2, stageCode: "IriaInquiryPending", title: "در انتظار احراز هویت", actorLabel: "ایریاپی" },
  { id: 3, stageCode: "IriaInquiryDone", title: "احراز هویت انجام شد", actorLabel: "ایریاپی" },
  { id: 4, stageCode: "IriaContractRequested", title: "درخواست فایل قرارداد", actorLabel: "ایریاپی" },
  { id: 5, stageCode: "IriaContractDownloaded", title: "دریافت فایل قرارداد", actorLabel: "ایریاپی" },
  { id: 6, stageCode: "IriaSignedUploaded", title: "آپلود فایل امضا شده", actorLabel: "متقاضی" },
  { id: 7, stageCode: "IriaBankPending", title: "در انتظار تأیید بانک", actorLabel: "بانک" },
  { id: 8, stageCode: "IriaDisburse", title: "اعطای تسهیلات", actorLabel: "ایریاپی" },
  { id: 9, stageCode: "IriaCompleted", title: "تکمیل شده", actorLabel: "ایریاپی" },
];

export const STEP_LOG_ACTION_PREFIX = "LM_STAGE_STEP";

export const buildStepActionTitle = (domain, stepId) =>
  `${STEP_LOG_ACTION_PREFIX}|${domain}|${stepId}`;

export const GATE_WARNING_TITLE =
  "شرط عبور به مرحله بعد (برنامه عملیاتی و ارجاع)";

export const GATE_WARNING_TEXT =
  "برای ورود به مرحله «برنامه عملیاتی و ارجاع» تکمیل فرآیندهای زیر الزامی است.";

export const GATE_PILL_MEHRSAN =
  "مهرسان: خریدار برق مهرسان باید ثبت و تا پایان تکمیل شود";

export const GATE_PILL_LOAN =
  "وام (در صورت نیاز): وام باید ثبت و تا پایان تکمیل شود";

export const LENDTECH_QUEUE_PATHS = {
  IRIA_PAY: "/SLN/SolarentOperator/IriaPay",
  BARQ_PAY: "/SLN/SolarentOperator/BarghPay",
};
